//page data
import { UserContext } from "vagaro-website-rendering/src/components/Definitions/UserContext";
import { AsyncAjaxDelete, AsyncAjaxGet, AsyncAjaxPost, AsyncAjaxPut } from "../../Common/AsyncAjaxService";
import { PageData, SiteData } from "../Data/SiteData";
import { GeneratePublishHTMLString } from "../GeneratePublishHTMLString";
import GetDateString from "./GetDateString";
import generateGlobalStyleFromSiteData from "vagaro-website-rendering/src/components/Utilities/GenerateGlobalStyleFromSiteData";
import { ValidateToken } from "vagaro-website-rendering/src/components/Utilities/BusinessData";
import { CreateBlankLayoutNode } from "../WBCanvas";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import LayoutNode, { getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { googleFonts } from "../StyleInputs/FontField";



const VagaroAPIEnum = {

    savePageContentAdmin: "LayoutPageFile/savecontent",
    savePageContentBusiness: "/websitebuilders/savecontent",

    loadPageContentAdmin: "LayoutPageFile/loadpagecontent?LayoutId=",
    loadPageContentBusiness: "/websitebuilders/loadpagecontent?LayoutId=",

    saveControlList: "/websitebuilders/setpagevclist",

    deletePageAdmin: "LayoutPageFile/deletepage",
    deletePageBusienss: "/websitebuilders/deletePage",

    getPageListBusiness: "/websitebuilders/getpagesbyownercontentless?LayoutId=",
    getPageListAdmin: "LayoutPageFile/getpagesbyownercontentless?LayoutId=",

    savePageStructureAdmin: "LayoutPageFile/savepagestructure",
    savePageStructureBusiness: "/websitebuilders/savebusinesspagestructure",

    getStylingAdmin: "style/getsitestyling?StyleID=",
    getStylingBusiness: "/websitebuilders/getbusinesslayoutstyling",

    saveStylingAdmin: "style/savesitestyling",
    saveStylingBusiness: "/websitebuilders/savebusinesslayoutstyling",

    createPageAdmin: "LayoutPageFile/createpage",
    createPageBusiness: "/websitebuilders/saveupdatepages",

    disableFolderAdmin:"LayoutPageFile/disablefolder?LayoutId=",
    disableFolderBusiness:"/websitebuilders/disablefolder?LayoutId=",

    hideFolderAdmin:"LayoutPageFile/hidefolder?LayoutId=",
    hideFolderBusiness:"/websitebuilders/hidefolder?LayoutId=",

    duplicateAllLocationFolderAdmin:"LayoutPageFile/duplicatealllocationfolder?LayoutId=",
    duplicateAllLocationBusiness:"/websitebuilders/duplicatealllocationfolder?LayoutId=",

    publishPageAdmin: "LayoutPageFile/publishlayout",
    publishPageBusiness: "/websitebuilders/publishwebsite",

    saveHeaderAdmin: "LayoutPageFile/saveheader",
    saveHeaderBusiness: "/websitebuilders/saveheader",

    saveFooterAdmin: "LayoutPageFile/savefooter",
    saveFooterBusiness: "/websitebuilders/savefooter",

    getBusinessLogo: "/businesslogo",

    LayoutPreview: "LayoutPageFile/layoutpreview?layoutId=",
    StylePreview: "style/getsitestyling?StyleID=",

    saveHistory:"/history/add",
    getHistoryList:"/history/list",
    getLayoutFromHistory:"/history/view?HID=",
    restoreHistory:"/history/restore?HID=",

    GetAllStyleName: "style/getallstylename",
    GetStyleList: "style/stylelist",
    ActivateStyle: "style/publish",
    DeactivateStyle: "style/deactivate",
    ChangeStyle: "/websitebuilders/changesstyle"

};

export async function LoadPageContentAsync(siteData: UserContext, pageId: string, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {
    let rootURL = (siteData.isAdmin) ? VagaroAPIEnum.loadPageContentAdmin : siteData.businessId + VagaroAPIEnum.loadPageContentBusiness;
    if(!pageId||pageId.length==0)
         rootURL = VagaroAPIEnum.LayoutPreview+siteData.layoutId;
    else
        rootURL +=  siteData.layoutId + "&PageId=" + pageId + "&EncMerchantId=" + siteData.businessId;

    await ValidateToken(siteData);

    await AsyncAjaxGet(
        rootURL,
        siteData.accessToken,
        function onSuccess(data: any) {
            if (onComplete) {
                onComplete(data);
            }
        },
        function OnError(data: any) {
            if (onFailure) {
                onFailure(data);
            }
        }
    )
}

export async function SaveVCList(siteData: UserContext, vcList: any[], onComplete?: (data: any) => void, onFailure?: (data: any) => void,isSharePreview:boolean = false) {

    await ValidateToken(siteData);
    let str = JSON.stringify(vcList);
    const obj = {
        PageVC:str,
        IsPreview:isSharePreview
    }
    const rootURL = siteData.businessId + VagaroAPIEnum.saveControlList;

    await AsyncAjaxPost(
        rootURL,
        JSON.stringify(obj),
        siteData.accessToken,
        function onSuccess(data: any) {
            if (onComplete) {
                onComplete(data);
            }
        },
        function OnError(data: any) {
            if (onFailure) {
                onFailure(data);
            }

        }
    );

}

export async function RestoreHistory(siteData: UserContext, historyId: string, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {

    await ValidateToken(siteData);
    const rootURL =  "merchants/"+siteData.businessId + VagaroAPIEnum.restoreHistory + historyId;

    await AsyncAjaxPost(
        rootURL,
        "",
        siteData.accessToken,
        function onSuccess(data: any) {
            if (onComplete) {
                onComplete(data);
            }
        },
        function OnError(data: any) {
            if (onFailure) {
                onFailure(data);
            }

        }
    );



}


export async function GetLayoutFromHistoryId(siteData: UserContext, historyId: string, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {

    await ValidateToken(siteData);
    const rootURL =  "merchants/"+siteData.businessId + VagaroAPIEnum.getLayoutFromHistory + historyId;

    await AsyncAjaxGet(
        rootURL,
        siteData.accessToken,
        function onSuccess(data: any) {
            if (onComplete) {
                onComplete(data?.data?.data);
            }
        },
        function OnError(data: any) {
            if (onFailure) {
                onFailure(data);
            }

        }
    );

}

export async function GetHistoryList(siteData: UserContext, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {

    await ValidateToken(siteData);
    const rootURL =  "merchants/"+siteData.businessId + VagaroAPIEnum.getHistoryList;

    await AsyncAjaxGet(
        rootURL,
        siteData.accessToken,
        function onSuccess(data: any) {
            if (onComplete) {
                onComplete(data?.data?.data);
            }
        },
        function OnError(data: any) {
            if (onFailure) {
                onFailure(data);
            }

        }
    );

}


export async function SaveHistory(siteData: UserContext, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {
    await ValidateToken(siteData);



    const rootURL = "merchants/"+siteData.businessId + VagaroAPIEnum.saveHistory;

    const data = {
        CreatedBy:siteData.userId,
        CreatedName:siteData.userName??"unknown",
    }
    await AsyncAjaxPost(
        rootURL,
        JSON.stringify(data),
        siteData.accessToken,
        function onSuccess(data: any) {
            if (onComplete) {
                onComplete(data);
            }
        },
        function OnError(data: any) {
            if (onFailure) {
                onFailure(data);
            }
        }
    );

}

export async function SavePageAsync(publish: boolean, siteData: UserContext, pageId: string, content: string, onComplete?: (data: any) => void, onFailure?: (data: any) => void,isSharePreview:boolean = false) {

  
    await ValidateToken(siteData);

    if (!pageId || pageId.length < 1) {
        console.warn("invalid page id");
    }
    let data;
    if (siteData.isAdmin) {
        data = JSON.stringify({
            LayoutId: siteData.layoutId,
            PageId: pageId,
            Content: content,
            CreatedBy: siteData.userId
        });
    }
    else {

        let sid = siteData.styleId;


        data = JSON.stringify({
            LayoutId: siteData.layoutId,
            StyleId: sid,
            PageId: pageId,
            Content: content,
            IsPublish: publish,
            CreatedBy: siteData.userId,
            IsPreview:isSharePreview
        });
    }
    if(content != "")
    {
        const rootURL = (siteData.isAdmin) ? VagaroAPIEnum.savePageContentAdmin : siteData.businessId + VagaroAPIEnum.savePageContentBusiness;
        await AsyncAjaxPost(
            rootURL,
            data,
            siteData.accessToken,
            function onSuccess(data: any) {
                if (onComplete) {
                    onComplete(data);
                }
            },
            function OnError(data: any) {
                if (onFailure) {
                    onFailure(data);
                }
            }
        );
    }
}

export const adminLogoData = {

        businessName:"Vagaro",
        imagePath:"https://f745786de3dd98dac855-36e09dc6f87385bab9d0e7ff5c0d38c7.ssl.cf2.rackcdn.com/WB/650a0427e80c5d177d422c76/Style_20230919211203.png"
    
}

export async function GetBusinessLogo(siteData: UserContext, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {

    if(siteData.isAdmin){ //return admin logo

        onComplete&&onComplete({data:{data:adminLogoData}});
        return;
    }


    await ValidateToken(siteData);

    const rootURL = "merchants/"+siteData.businessId + VagaroAPIEnum.getBusinessLogo;
    await AsyncAjaxGet(
        rootURL,
        siteData.accessToken,
        function onSuccess(data: any) {

    
            if (onComplete) {
                onComplete(data);
            }
        },
        function OnError(data: any) {

            if (onFailure) {
                onFailure(data);
            }
        }
    );
}

export async function DeletePageAsync(siteData: UserContext, pageId: string, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {
    
    await ValidateToken(siteData);

    
    const rootURL = (siteData.isAdmin) ? VagaroAPIEnum.deletePageAdmin + "?LayoutId=" + siteData.layoutId + "&PageId=" + pageId : siteData.businessId + VagaroAPIEnum.deletePageBusienss + "?LayoutId=" + siteData.layoutId + "&StyleId=" + siteData.styleId + "&PageId=" + pageId;
    await AsyncAjaxDelete(
        rootURL,
        siteData.accessToken,
        function onSuccess(data: any) {
            if (onComplete) {
                onComplete(data);
            }
        },
        function OnError(data: any) {
            if (onFailure) {
                onFailure(data);
            }
        }
    );
}

export async function SaveHeaderAsync(publish: boolean, siteData: UserContext, header: string, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {
    
    await ValidateToken(siteData);  
    const rootURL = (siteData.isAdmin) ? VagaroAPIEnum.saveHeaderAdmin : siteData.businessId + VagaroAPIEnum.saveHeaderBusiness;
    var content;
    if (siteData.isAdmin) {
        content = JSON.stringify({
            LayoutId: siteData.layoutId,
            Header: header
        })
    }
    else {
        content = JSON.stringify({
            Header: header
        })
    }

    if(!content||content.length<4){ // check for content being {} or null
        console.warn("invalid header content",header);
        if(onFailure)
        onFailure("invalid header content");
        return;
    }

    await AsyncAjaxPost(
        rootURL,
        content,
        siteData.accessToken,
        function onSuccess(data: any) {
            if (onComplete) {
                onComplete(data);
            }
        },
        function OnError(data: any) {
            if (onFailure) {
                onFailure(data);
            }
        }
    );
}

export async function SaveFooterAsync(publish: boolean, siteData: UserContext, footer: string, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {
   
    await ValidateToken(siteData);

   
    const rootURL = (siteData.isAdmin) ? VagaroAPIEnum.saveFooterAdmin : siteData.businessId + VagaroAPIEnum.saveFooterBusiness;
    var content;
    if (siteData.isAdmin) {
        content = JSON.stringify({
            LayoutId: siteData.layoutId,
            Footer: footer
        })
    }
    else {
        content = JSON.stringify({
            Footer: footer
        })
    }

    if(!content||content.length<4){// check for content being {} or null
        console.warn("invalid footer content",footer);

        if(onFailure)
        onFailure("invalid header content");

        return;
    }

    await AsyncAjaxPost(
        rootURL,
        content,
        siteData.accessToken,
        function onSuccess(data: any) {
            if (onComplete) {
                onComplete(data);
            }
        },
        function OnError(data: any) {
            if (onFailure) {
                onFailure(data);
            }

        }
    );
}

export async function CreateNewPage(newID:string,siteData: SiteData, pageName: string, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {
    if(!siteData.isModifyAllowed){
        if(onFailure)
            onFailure("Not allowed to modify");
        return;

    }
    const savePage = {
        PageId: newID,
        LayoutId: siteData.userContext.layoutId,
        StyleId: siteData.userContext.styleId,
        PageName: pageName,
        UrlSlug: "/" + pageName.replaceAll(" ", "-").toLowerCase(),
        TitleTag: "",
        Description: "",
        IsFolder: false,
        FolderId: "",
        OpenGraphURL:"",
        PageOrder: -1,
        IsDisabled: false,
        isLandingPage: false,
        isHidePage: false,
        isDuplicateAllLocationPage:false,
      }

    await CreateOrUpdatePage(siteData, savePage, onComplete, onFailure);

}

export async function HideFolder(siteData: SiteData,isHide:boolean, folderId: string, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {
    if(!siteData.isModifyAllowed){
        if(onFailure)
            onFailure("Not allowed to modify");
        return;

    }

    await ValidateToken(siteData.userContext);

    const rootURL = ((siteData.userContext.isAdmin) ? VagaroAPIEnum.hideFolderAdmin : (siteData.userContext.businessId + VagaroAPIEnum.hideFolderBusiness)) +siteData.userContext.layoutId+"&FolderId="+folderId+"&flag="+isHide.toString();

    await AsyncAjaxDelete(
        rootURL,
        siteData.userContext.accessToken,
        function onSuccess(data: any) {
            if (onComplete) {
                onComplete(data);
            }
        },
        function OnError(data: any) {
            if (onFailure) {
                onFailure(data);
            }
        }
    );

}


export async function DuplicateAllLocationFolder(siteData: SiteData,isHide:boolean, folderId: string, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {
    if(!siteData.isModifyAllowed){
        if(onFailure)
            onFailure("Not allowed to modify");
        return;

    }

    await ValidateToken(siteData.userContext);

    const rootURL = ((siteData.userContext.isAdmin) ? VagaroAPIEnum.duplicateAllLocationFolderAdmin : (siteData.userContext.businessId + VagaroAPIEnum.duplicateAllLocationBusiness)) +siteData.userContext.layoutId+"&FolderId="+folderId+"&flag="+isHide.toString();

    await AsyncAjaxDelete(
        rootURL,
        siteData.userContext.accessToken,
        function onSuccess(data: any) {
            if (onComplete) {
                onComplete(data);
            }
        },
        function OnError(data: any) {
            if (onFailure) {
                onFailure(data);
            }
        }
    );

}

export async function DisableFolder(siteData: SiteData,isDisable:boolean, folderId: string, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {
    if(!siteData.isModifyAllowed){
        if(onFailure)
            onFailure("Not allowed to modify");
        return;

    }

    await ValidateToken(siteData.userContext);

    const rootURL = ((siteData.userContext.isAdmin) ? VagaroAPIEnum.disableFolderAdmin : (siteData.userContext.businessId + VagaroAPIEnum.disableFolderBusiness))+siteData.userContext.layoutId+"&FolderId="+folderId+"&flag="+isDisable.toString();

    await AsyncAjaxDelete(
        rootURL,
        siteData.userContext.accessToken,
        function onSuccess(data: any) {
            if (onComplete) {
                onComplete(data);
            }
        },
        function OnError(data: any) {
            if (onFailure) {
                onFailure(data);
            }
        }
    );

}

export async function CreateOrUpdatePage(siteData: SiteData, page: any, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {
    if(!siteData.isModifyAllowed){
        if(onFailure)
            onFailure("Not allowed to modify");
        return;

    }
    await ValidateToken(siteData.userContext);


    const userContext = siteData.userContext;
    const rootURL = (userContext.isAdmin) ? VagaroAPIEnum.createPageAdmin : userContext.businessId + VagaroAPIEnum.createPageBusiness;
    if (!userContext.isAdmin) {
        page = {
            ...page,
            createdData: new Date().toString(),
            createdBy: userContext.userId,
        }
    }
    await AsyncAjaxPost(
        rootURL,
        page,
        userContext.accessToken,
        function onSuccess(data: any) {
            if (onComplete) {
                onComplete(data);
            }
        },
        function OnError(data: any) {
            if (onFailure) {
                onFailure(data);
            }
        }
    );
}

export async function getAllPagesContentless(siteData: UserContext, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {

    await ValidateToken(siteData);



    const rootURL = (siteData.isAdmin) ? VagaroAPIEnum.getPageListAdmin : siteData.businessId + VagaroAPIEnum.getPageListBusiness;
    await AsyncAjaxGet(
        rootURL + siteData.layoutId,
        siteData.accessToken,
        function onSuccess(data: any) {
            if (onComplete) {
                onComplete(data);
            }
        },
        function OnError(data: any) {
            if (onFailure) {
                onFailure(data);
            }
        }
    );
}

export async function SavePageStructure(siteData: SiteData, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {
    if(!siteData.isModifyAllowed){
        if(onFailure)
            onFailure("Not allowed to modify");
        return;

    }
 

    await ValidateToken(siteData.userContext);


    siteData.isPageListPublishDirty = true;
    const getSavePageFromPageData = (page: PageData, folder: PageData | null, order: number) => {
        let savePage: SavePageData = {
            PageId: page.pageId,
            PageName: page.name,
            FolderId: folder?.pageId ?? "",
            FolderName: folder?.name ?? "",
            PageOrder: order,
            URLSlug: page.url ?? ""
        }
        return savePage;
    }

    let savePages = [];
    let order = 1; // start at one so that newly created pages will default to the top
    for (let i = 0; i < siteData.pages.length; i++) {

        let page = siteData.pages[i];
        let savePage = getSavePageFromPageData(page, null, order);
        order++;
        savePages.push(savePage);
        if (page.children && page.children.length > 0) {
            for (let e = 0; e < page.children.length; e++) {
                order++;
                let child = page.children[e];
                let saveChild = getSavePageFromPageData(child, page, order);
                savePages.push(saveChild);
            }
        }
    }

    let saveData = {
        LayoutId: siteData.userContext.layoutId,
        LayoutPages: savePages
    }


    const rootURL = (siteData.userContext.isAdmin) ? VagaroAPIEnum.savePageStructureAdmin : siteData.userContext.businessId + VagaroAPIEnum.savePageStructureBusiness;
    await AsyncAjaxPost(
        rootURL,
        JSON.stringify(saveData),
        siteData.userContext.accessToken,
        function onSuccess(data: any) {
            if (onComplete) {

                onComplete(data);
            }
        },
        function OnError(data: any) {
            if (onFailure) {
                onFailure(data);
            }

        }
    );
}

export async function GetSiteStyleAsync(siteData: UserContext, onComplete?: (data: any) => void, onFailure?: (data: any) => void,forceAdmin = false) {

    await ValidateToken(siteData);


    const rootURL = (siteData.isAdmin||forceAdmin) ? VagaroAPIEnum.getStylingAdmin + siteData.styleId : siteData.businessId + VagaroAPIEnum.getStylingBusiness;
    await AsyncAjaxGet(
        rootURL,
        siteData.accessToken,
        function onSuccess(data: any) {
            if (onComplete) {
                onComplete(data);
            }
        },
        function OnError(data: any) {
            if (data?.data?.data?.siteStyling) {
                if (onComplete) {
                    onComplete(data);
                }
            }
            else if (onFailure) {
                onFailure(data);
            }
        }
    );
}

export async function SaveSiteStyle(siteData: SiteData, onComplete?: (data: any) => void, onFailure?: (data: any) => void) {
    if(!siteData.isModifyAllowed){
        if(onFailure)
            onFailure("Not allowed to modify");
        return;

    }

    await ValidateToken(siteData.userContext);


    const rootURL = (siteData.userContext.isAdmin) ? VagaroAPIEnum.saveStylingAdmin : siteData.userContext.businessId + VagaroAPIEnum.saveStylingBusiness;

    const imageURLS = siteData.imageUrls.filter((item)=>item!=adminLogoData.imagePath);//filter out logo
    const siteString = {
        styling: siteData.siteStyling,
        imageUrls: imageURLS,
        lastPublishDate: siteData.lastPublishDate??"",
        homePageId: siteData.homePageId,
    }
    const content = JSON.stringify(siteString);

    let data;
    if (siteData.userContext.isAdmin) {
        data = JSON.stringify(
            {
                StyleID: siteData.userContext.styleId,
                SiteStyling: content
            }
        )
    }
    else {
        data = JSON.stringify(
            {
                SiteStyling: content
            }
        )
    }
    await AsyncAjaxPut(
        rootURL,
        siteData.userContext.accessToken,
        data,
        function onSuccess(data: any) {
            if (onComplete) {
                onComplete(data);
            }
        },
        function OnError(data: any) {
            if (onFailure) {
                onFailure(data);
            }
        }
    );
}

export async function PublishPage(siteData: SiteData, pageId: string, content: string,headerAndFooterStyling:string, headerContent: string, footerContent: string, IsPreview:boolean, onComplete?: (data: any) => void, onFailure?: (data: any) => void,firstPublish?:boolean ) {

    if(!siteData.isModifyAllowed){
        if(onFailure)
            onFailure("Not allowed to modify");
        return;

    }
    /*
    1. Update the publish date of the template
    2. Publish the page content for the provided page (using save page with isPublish=true)
    3. If other pages are empty, proceed to load all pages into memory and publish teir content as well
    */
    await ValidateToken(siteData.userContext);

    if (!IsPreview) {
        await SaveHistory(
          siteData.userContext,
          (data) => {},
          () => {
            console.warn("failed to save history");
          }
        );
      }
    const userContext = siteData.userContext;

    const saveContentRoot = (userContext.isAdmin) ? VagaroAPIEnum.savePageContentAdmin : userContext.businessId + VagaroAPIEnum.savePageContentBusiness;
    const updatePublishRoot = (userContext.isAdmin) ? VagaroAPIEnum.publishPageAdmin : userContext.businessId + VagaroAPIEnum.publishPageBusiness;

    const templateName = (userContext.isAdmin) ? "LayoutId" : "BusinessLayoutId";

    let fontAHref = googleFonts.includes(siteData.siteStyling.fontPrimary)?"https://fonts.googleapis.com/css?family="+siteData.siteStyling.fontPrimary.replaceAll(" ","+"):"";
    let fontBHref = googleFonts.includes(siteData.siteStyling.fontPrimary)?"https://fonts.googleapis.com/css?family="+siteData.siteStyling.fontSecondary.replaceAll(" ","+"):"";


    //create a comment block in the style with the neccisary includes so that we can split and load them when rendering
    let siteStyle = generateGlobalStyleFromSiteData(siteData.siteStyling)+"\n"+headerAndFooterStyling +" /*vwb-font-includes "+fontAHref+" , "+fontBHref+" , ";

    for(let i = 0;i<siteData.siteStyling.customFonts.length;i++){
        siteStyle+=siteData.siteStyling.customFonts[i]+" , ";
    }

    siteStyle+="*/";

  
   
    const publishData = JSON.stringify({
        [templateName]: userContext.layoutId,
        ModifyBy: userContext.userId,
        ModifiedDate: GetDateString(),
        Footer_Publish: footerContent,
        Header_Publish: headerContent,
        StyleContent_Publish: siteStyle,
        IsPreview : IsPreview
    });

    const contentData = JSON.stringify({
        LayoutId: userContext.layoutId,
        StyleId: userContext.styleId,
        PageId: pageId,
        Content: content,
        IsPublish: true,
        IsPreview : IsPreview,

    });


    const mainResult:any ={
        data:null
    }

    //mark publish date
    await AsyncAjaxPost(updatePublishRoot, publishData, userContext.accessToken, (data: any) => {mainResult.data=data;}, onFailure);
   
 

    if(!mainResult.data){
        onFailure && onFailure(mainResult.data);
    }
    //save intial page regardless of return value
    await  AsyncAjaxPost(saveContentRoot, contentData, userContext.accessToken, (data: any) => {
    }, onFailure);

    let pageData = mainResult?.data?.data?.data;

    //not a valid response
    if (!pageData&&!userContext.isAdmin) { 
        onFailure && onFailure(mainResult.data);
        return;
    }


    //remove duplicates...
    for(let i = 0;i<pageData.length;i++){
        for(let  e= i+1;e<pageData.length;e++){

            if(pageData[i].pageId == pageData[e].pageId){
                pageData.splice(e,1);
                e--;
            }

        }

    }


    const componentInfoResults:any[]  = [];

    const promiseList = []


    for (let i = 0; i < pageData.length; i++) {
        try {
            let page = pageData[i];            

            const info = GetPageComponentInfo(page.pageId,page.content,siteData);

            let found = false;

            for(let e = 0;e<componentInfoResults.length;e++){
                if(componentInfoResults[e].URLSlug == info.URLSlug){
                    found = true;
                    break;
                }
            }

            if(info.URLSlug.length>0 &&!found &&info.component.length>0)
                componentInfoResults.push(info);
            


            if (page.pageId === pageId) {
                continue; // skip the page we just published
            }
            if (!page.content || page.content.length < 1 ) { // if empty, load then publish
      
                promiseList.push( LoadPageThenPublish(siteData, page.pageId, onFailure,IsPreview));
            }
            else if(!userContext.isAdmin ){ // remove additional json check to account for possibility of json being out of order

                let pageData = userContext.pages.find((item)=>item.pageId == page.pageId);
                let alreadyMultiPublished = true;
                let alreadyPublished = page.content.includes("vwbpublished");
                if(pageData && pageData.isDuplicateAllLocationPage){
                    alreadyMultiPublished =  page.content.includes("vwbmultipublished");
                }
            
             
       
         
                //on initial save load the page and set the vwbpublished flag to 1 so it can be avoided on future calls
                if(!alreadyPublished||!alreadyMultiPublished ||IsPreview || (firstPublish) ){ 
                 
                    let node:LayoutNode = JSON.parse(page.content);

                    //only set publish flag if not in preview
                    if(!alreadyPublished&&!IsPreview)
                        setNodeComponentAttributeValue(node,"vwbpublished","1");
                    if(!alreadyMultiPublished&&!IsPreview)
                        setNodeComponentAttributeValue(node,"vwbmultipublished","1");

                    const content = JSON.stringify(node);
                

                    promiseList.push( SavePageAsync(false,userContext,page.pageId,content,()=>{},onFailure,IsPreview));
                    promiseList.push( PublishPageContent(siteData,page.pageId,content,()=>{},onFailure,IsPreview));
                   

                }
               
            }
            
        }
        catch (e) {
            console.warn(e);
        }
    }

    await Promise.all(promiseList);

    if(!IsPreview){
        siteData.isFooterPublishDirty = false;
        siteData.isHeaderPublishDirty = false;
        siteData.isPageListPublishDirty = false;
        siteData.isStylePublishDirty = false;
    }

    
    await  SaveVCList(siteData.userContext,componentInfoResults,()=>{
        onComplete && onComplete(mainResult.data);
    },()=>{
        onFailure && onFailure(mainResult.data)
    },IsPreview);






    // //mark the publish date then evaluate WHAT actually needs to be published
    // await AsyncAjaxPost(updatePublishRoot, publishData, userContext.accessToken, (data: any) => {



    //     //save the initial page regardless of return value
    //     AsyncAjaxPost(saveContentRoot, contentData, userContext.accessToken, (data: any) => {
    //     }, onFailure);

    //     let pageData = data?.data?.data;
    //     if (!pageData) { // invalid response
    //         onFailure && onFailure(data);
    //         return;
    //     }

  
    //     //evaluate data and see if any other pages need to be published for the first time
    //     //@TODO temp fix for iconic, publish API not returning full list of pages, brute force publish all pages for now

    //     const componentInfoResults:any[]  = [];

   

    //     for (let i = 0; i < pageData.length; i++) {
    //         try {
    //             let page = pageData[i];

    //             const info = GetPageComponentInfo(page.pageId,page.content,siteData);
    //             let found = false;
    //             for(let e = 0;e<componentInfoResults.length;e++){
    //                 if(componentInfoResults[e].URLSlug == info.URLSlug){
    //                     found = true;
    //                     break;
    //                 }
    //             }

    //             if(info.URLSlug.length>0 &&!found &&info.component.length>0)
    //                 componentInfoResults.push(info);
                


    //             if (page.pageId === pageId) {
    //                 continue; // skip the page we just published
    //             }
    //             if (!page.content || page.content.length < 1 ) { // extra check incase json exists where html should 
    //                 LoadPageThenPublish(siteData, page.pageId, onFailure);
    //             }
    //             else if((!userContext.isAdmin && page.content.startsWith('{"id":'))){
    //                 PublishPageContent(siteData,page.pageId,page.content,()=>{},onFailure);
    //             }
    //         }
    //         catch (e) {
    //             console.warn(e);
    //         }
    //     }

    //     SaveVCList(siteData.userContext,componentInfoResults,()=>{
    //         onComplete && onComplete(data);
    //     },()=>{
    //         onFailure && onFailure(data)
    //     });
        
        
    // }, (data: any) => {
    //     onFailure && onFailure(data)
    // });


    // //after publish reset dirty flags so next publish doesn't try to publish everything again
    // siteData.isFooterPublishDirty = false;
    // siteData.isHeaderPublishDirty = false;
    // siteData.isPageListPublishDirty = false;
    // siteData.isStylePublishDirty = false;

}

export const MainBusienssControlTypes = [
    wBComponentTypeNames.busienssStaff,
    wBComponentTypeNames.businessClass,
    wBComponentTypeNames.businessServices,
    wBComponentTypeNames.businessPackages,
    wBComponentTypeNames.businessDailyDeals,
    wBComponentTypeNames.businessMemberships,
    wBComponentTypeNames.businessProducts,
    wBComponentTypeNames.businessBookNow,
    wBComponentTypeNames.businessGiftCertificates,
    wBComponentTypeNames.businessDescription,
    wBComponentTypeNames.businessReviews,
    wBComponentTypeNames.busienssStaff,
    wBComponentTypeNames.businessGallery,
    wBComponentTypeNames.businessHours,
    wBComponentTypeNames.businessFacilityInformation,
    wBComponentTypeNames.businessMap,
    wBComponentTypeNames.businessreviewpercentage,
    wBComponentTypeNames.businessMessage,
    wBComponentTypeNames.businessCall,
    wBComponentTypeNames.businessContactLess,
    wBComponentTypeNames.businessName,
    wBComponentTypeNames.businessLogo,
    wBComponentTypeNames.businessLocation,




]

export const HidableBusinessControlTypes = [
   
    wBComponentTypeNames.businessClass,
    wBComponentTypeNames.businessServices,
    wBComponentTypeNames.businessPackages,
    wBComponentTypeNames.businessDailyDeals,
    wBComponentTypeNames.businessMemberships,
    wBComponentTypeNames.businessProducts,
    wBComponentTypeNames.businessBookNow,
    wBComponentTypeNames.businessGiftCertificates,



]

function GetPageComponentInfo(pageId: string, pageContent:string, siteData: SiteData) {
   
    let url = "";
 
    for(let i = 0;i<siteData.pages.length;i++){
        const mPage = siteData.pages[i];
        let shouldBreak = false;
        if(mPage.pageId == pageId){
            url = mPage.url??"/";
            break;
        }
        else if(mPage.isFolder&&mPage.children&&mPage.children.length>0){
            for(let j = 0;j<mPage.children.length;j++){
                const mChild = mPage.children[j];
                if(mChild.pageId == pageId){
                    url = mChild.url??"/";
                    shouldBreak = true;//falg to break out of outer loop
                    break;
                }
            }
        }
        if(shouldBreak)
            break;
    }
    const toReturn:any = {
        URLSlug:url,
        component:[]
    }
    try{
        let content:LayoutNode = JSON.parse(pageContent);

        let pendingList = [content];

        while(pendingList.length>0){
            let node = pendingList.pop();
            if(node?.children)
            for(let i = 0;i<node.children.length;i++){
                pendingList.push(node.children[i]);
            }

            if(node)
            if(MainBusienssControlTypes.indexOf(node.typename)>=0){
               toReturn.component.push({
                Type:node.typename,
                location: getNodeComponentAttributeValue(node,componentAttributeTypes.multiLocation,siteData.userContext.businessId),
               })
            }

        }

    }
    catch(e){
        console.warn(e);
    }

 
    return toReturn;

}


export function GetBusinessControlListFromNode(node:LayoutNode){

    let pending = [node];
    let componentList:string[] = [];

    while(pending.length>0){
        let n = pending.pop();
        if(!n)
            return componentList;

        if(HidableBusinessControlTypes.indexOf(n.typename)>=0){
            componentList.push(n.typename);
        }

        for(let i = 0;i<n.children.length;i++){
            pending.push(n.children[i]);
        
        }

    }

    return componentList;

}


//Loads the page content, converts to HTML if not an admin user, then publishes the HTML via the SavePageContent(IsPublish = true)
async function LoadPageThenPublish(siteData: SiteData, pageId: string, onFailure?: (data: any) => void,isPreview:boolean = false) {


    await ValidateToken(siteData.userContext);


    LoadPageContentAsync(siteData.userContext, pageId, (data: any) => {



        try {
            const content = data.data.data.content??"";

            const node = (content.length>0)?JSON.parse(content):CreateBlankLayoutNode(wBComponentTypeNames.pageRoot);
            const html = (siteData.userContext.isAdmin) ? content : GeneratePublishHTMLString(node, siteData, false,true);
      
            SavePageAsync(true, siteData.userContext, pageId, html, (data: any) => {

            }, (data: any) => {
                onFailure && onFailure(data);
                console.warn("saving error",data);
            },isPreview)
        }
        catch (e) {
            console.warn("error saving page",e);
            onFailure && onFailure(data);
        }
    }, (data: any) => {
        onFailure && onFailure(data);
    })
}

async function PublishPageContent(siteData:SiteData,pageId:string,content:string,onComplete?: (data: any) => void, onFailure?: (data: any) => void,isPreview:boolean = false){

    const node = (content.length>0)?JSON.parse(content):CreateBlankLayoutNode(wBComponentTypeNames.pageRoot);
    const html = (siteData.userContext.isAdmin) ? content : GeneratePublishHTMLString(node, siteData, false,true);

    SavePageAsync(true, siteData.userContext, pageId, html, (data: any) => {
        onComplete && onComplete(data);
    }, (data: any) => {
        onFailure && onFailure(data);
        console.warn("saving error",data);
    },isPreview)

}





export type SavePageData = {
    PageId: string;
    PageName: string;
    FolderId: string;
    FolderName: string;
    PageOrder: number;
    URLSlug: string;
}

export async function GetStyleListForLayoutId(userContext:UserContext,realId:number,onComplete?: (data: any) => void, onFailure?: (data: any) => void,pageSize:number = 50){
    const Requestdata:any = {};
    Requestdata.CategoryID =  "";//categoryId.current;
    Requestdata.SubCategoryID = "";//subCategoryId.current;
    const arrFilter:number[] = [2];

   Requestdata.Filter = arrFilter;
    const arraySorting:number[] = [12];

    Requestdata.Sortedby = arraySorting;
    Requestdata.PageIndex = 1;
    Requestdata.PageSize = pageSize;
    Requestdata.MerchantId = realId
    Requestdata.LoginUserId = userContext.userId;
    await AsyncAjaxPost(
         VagaroAPIEnum.GetStyleList,
         Requestdata,
         userContext.accessToken,
         function onSuccess(data:any) {
 
            onComplete&&onComplete(data);
         },
         function OnError(data:any) {
     
            onFailure&&onFailure(data);
         }
    );


}

export async function ActivateDefaultStyle(siteData:SiteData,onComplete?: (data: any) => void, onFailure?: (data: any) => void){

    ValidateToken(siteData.userContext);
    
    await AsyncAjaxGet(
        VagaroAPIEnum.GetAllStyleName,
       siteData.userContext.accessToken,
        function onSuccess(data:any) {
            try {
                if (data?.data?.data) {
                    let first = data.data.data[0];
                    if(first?.styleId){
               
                        siteData.userContext.styleId = first.styleId;
                        ChangeStyle(siteData.userContext,first.styleId,onComplete,onFailure);
                     
                    }
                    else{
                      
                        onFailure&&onFailure("No Style ID Found");
                        
                    }
                }
            } catch (error) { console.error("No Style ID Found"); }
        },
        function OnError() { 
          
            onFailure&&onFailure("No Style ID Found");
        }
    )


}

export async function ChangeStyle(userContext:UserContext,styleId:string,onComplete?: (data: any) => void, onFailure?: (data: any) => void){

    ValidateToken(userContext);
    

    await AsyncAjaxPut(
        userContext.businessId+VagaroAPIEnum.ChangeStyle + "?styleId=" + styleId,
        userContext.accessToken,
        null,(data:any)=>{

            onComplete&&onComplete(data);

        },(data:any)=>{

            onFailure&&onFailure(data);
        }
    )

}